import type { HighlightedTextProps } from "./types";

export const HighlightedText = ({
  text,
  searchQuery,
}: HighlightedTextProps) => {
  const normalizedSearchQuery = searchQuery.trim().toLowerCase();

  const matchStart =
    normalizedSearchQuery === ""
      ? -1
      : text.toLowerCase().indexOf(normalizedSearchQuery);

  if (matchStart < 0) return <>{text}</>;

  const matchEnd = matchStart + normalizedSearchQuery.length;

  return (
    <>
      {text.slice(0, matchStart)}
      <mark className="rounded-sm bg-yellow-200 text-gray-900">
        {text.slice(matchStart, matchEnd)}
      </mark>
      {text.slice(matchEnd)}
    </>
  );
};
